export const addMinutes = (timeString: string, minuteToAdd: number): string => {
  const [hour, minute] = timeString.split(':').map(Number)
  const date = new Date()
  date.setHours(hour)
  date.setMinutes(minute + minuteToAdd)
  const newTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  return newTime
}
